import React from "react";
import {
  Box, Typography, Button, Dialog, DialogContent, DialogActions, Divider
} from "@mui/material";
import { CheckCircle, PictureAsPdf, ShoppingCart } from "@mui/icons-material";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function PasoExito({ compra, onFinalizar, onNuevaCompra }) {
  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
  };

  const descargarPDFCompra = async () => {
    if (!compra) return;
    try {
      const response = await axios.get(
        `${API_URL}/api/contabilidad/compras/${compra.id}/pdf`,
        { headers: getAuthHeaders(), responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Compra_${compra.factura?.numeroComprobante || compra.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar PDF:", error);
      alert("Error al descargar el PDF de la compra");
    }
  };

  if (!compra) return null;

  return (
    <Dialog open={true} maxWidth="sm" fullWidth>
      <DialogContent sx={{ textAlign: "center", py: 4 }}>
        <CheckCircle sx={{ fontSize: 64, color: "#4CAF50", mb: 2 }} />
        
        <Typography variant="h5" fontWeight={700} gutterBottom>
          ¡Compra Registrada!
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          La compra ha sido registrada correctamente en el sistema.
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ textAlign: "left", mb: 2 }}>
          <Typography variant="body2" color="text.secondary">Proveedor</Typography>
          <Typography variant="body1" fontWeight={600}>
            {compra.proveedor?.razonSocial || compra.proveedor?.razon_social || "—"}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Box sx={{ textAlign: "left" }}>
            <Typography variant="body2" color="text.secondary">Factura</Typography>
            <Typography variant="body1" fontWeight={600}>
              {compra.factura?.numeroComprobante || "—"}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "right" }}>
            <Typography variant="body2" color="text.secondary">Total</Typography>
            <Typography variant="h6" color="primary" fontWeight={700}>
              ${compra.totales?.importeTotal || compra.total || "0.00"}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3, flexWrap: "wrap" }}>
        <Button
          variant="outlined"
          size="large"
          startIcon={<ShoppingCart />}
          onClick={onNuevaCompra}
          sx={{ flex: 1, minWidth: 150 }}
        >
          Nueva Compra
        </Button>
        <Button
          variant="contained"
          size="large"
          startIcon={<PictureAsPdf />}
          onClick={descargarPDFCompra}
          sx={{ flex: 1, minWidth: 150 }}
          color="error"
        >
          Descargar PDF
        </Button>
        <Button
          variant="text"
          size="large"
          onClick={onFinalizar}
          sx={{ width: "100%", mt: 1 }}
        >
          Cerrar y volver a Compras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
